import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { MessageCircle, X } from "lucide-react";

const WA_MSG = encodeURIComponent(
  "Assalamualaikum Cikgu, saya berminat nak tahu info detail kelas, yuran & jadual Kelas Program Membaca PMM."
);

const MANAGERS = [
  {
    key: "fizikal",
    name: "Cikgu Shafie",
    phoneDisplay: "016-7202689",
    wa: `https://wa.me/60167202689?text=${WA_MSG}`,
    roleMs: "Pengurus Kelas Fizikal PMM",
    roleEn: "PMM Physical Class Manager",
  },
  {
    key: "sabah",
    name: "Cikgu Imran",
    phoneDisplay: "013-8997675",
    wa: `https://wa.me/60138997675?text=${WA_MSG}`,
    roleMs: "Pengurus Kelas PMM Sabah",
    roleEn: "PMM Sabah Class Manager",
  },
  {
    key: "online",
    name: "Cikgu Zarith",
    phoneDisplay: "017-8730024",
    wa: `https://wa.me/60178730024?text=${WA_MSG}`,
    roleMs: "Pengurus Kelas Online PMM Malaysia",
    roleEn: "PMM Malaysia Online Class Manager",
  },
];

export default function FloatingWhatsApp() {
  const { lang } = useI18n();
  const ms = lang === "ms";
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Sembunyikan pada skrin kiosk (device pejabat)
  if (location.pathname.startsWith("/kiosk")) return null;

  return (
    <div className="fixed bottom-24 right-4 z-50 flex flex-col items-end gap-3 md:bottom-6 md:right-6" data-testid="floating-whatsapp">
      {open && (
        <div className="w-72 overflow-hidden rounded-2xl border border-border bg-white shadow-2xl" data-testid="floating-whatsapp-panel">
          <div className="flex items-center justify-between bg-[#25D366] px-4 py-3">
            <div className="flex items-center gap-2 text-white">
              <MessageCircle className="h-5 w-5" />
              <span className="font-display text-sm font-extrabold uppercase tracking-wide">
                {ms ? "WhatsApp Pengurus PMM" : "WhatsApp PMM Manager"}
              </span>
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="grid h-7 w-7 place-items-center rounded-full bg-white/20 text-white transition-colors hover:bg-white/30"
              aria-label={ms ? "Tutup" : "Close"}
              data-testid="floating-whatsapp-close"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <p className="px-4 pt-3 text-xs font-semibold text-muted-foreground">
            {ms
              ? "Info detail kelas, yuran & jadual — pilih pengurus:"
              : "Class details, fees & schedule — choose a manager:"}
          </p>
          <div className="p-2">
            {MANAGERS.map((m) => (
              <a
                key={m.key}
                href={m.wa}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 rounded-xl px-3 py-2.5 transition-colors hover:bg-[#25D366]/10"
                data-testid={`floating-whatsapp-${m.key}`}
              >
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#25D366] text-white shadow-md">
                  <MessageCircle className="h-5 w-5" />
                </span>
                <span className="min-w-0">
                  <span className="block truncate text-sm font-bold text-blue-900">
                    {m.name} · {m.phoneDisplay}
                  </span>
                  <span className="block truncate text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
                    {ms ? m.roleMs : m.roleEn}
                  </span>
                </span>
              </a>
            ))}
          </div>
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="relative grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-2xl shadow-green-600/40 transition-transform duration-300 hover:scale-110"
        aria-label={ms ? "WhatsApp Pengurus PMM" : "WhatsApp PMM Manager"}
        data-testid="floating-whatsapp-btn"
      >
        {!open && <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/50" />}
        {open ? <X className="h-7 w-7" /> : <MessageCircle className="h-7 w-7" />}
      </button>
    </div>
  );
}
